import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const address = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    legalAddress: z
      .string()
      .nullable()
      .optional()
      .describe('Legal address as in document.'),

    city: z.string().nullable().optional().describe('City.'),

    country: z.string().nullable().optional().describe('Country.'),

    currentAddress: z
      .string()
      .nullable()
      .optional()
      .describe('Current address.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    candidate: belongsTo('Candidate'),
  })
  .describe('Legal and current address information for a candidate.')
  .as('Address');

export { address as addressSchema };
